module.exports = __webpack_public_path__ + "img/ad-chuyi.cb187bac.jpg";